export default "__VITE_ASSET__Q4UDqKHMNbMzC1JLGzBzYg__";